module.exports = __webpack_public_path__ + "static/media/camera-white.a4a356b4.svg";